const EshramSuccessPage = ({ applicationId, company }) => {
    return (
      <>
        <div className="text-xl text-[#4D4D4D] font-sans font-bold my-7 px-5">
          Thank you for submitting information. / ಮಾಹಿತಿಯನ್ನು ಸಲ್ಲಿಸಿದ್ದಕ್ಕಾಗಿ ಧನ್ಯವಾದಗಳು.
        </div>
        <div className="my-5 px-5">
          <div className="text-base text-[#4D4D4D] font-sans">
            Our team will reach out to you with further process very soon. / ನಮ್ಮ ತಂಡವು ಮುಂದಿನ ಪ್ರಕ್ರಿಯೆಯೊಂದಿಗೆ ನಿಮ್ಮನ್ನು ತಲುಪುತ್ತದೆ.
          </div>
        </div>
      </>
    );
  };
  
  export default EshramSuccessPage;
  